/**
 * 判斷是否為 json 格式
 * true 轉換成 javascript 可用的格式
 * false 返回空字串
 * @param {string} string json 字串
 */
 export const handleJson = string => {
  try {
      return JSON.parse(string)
  } catch (error) {
      return ''
  }
}

/**
 * 設定 localStorage
 * true 返回 localStorage 並進行 json 檢測
 * false 返回空字串
 * @param {string} key localStorage 的 Key
 * @param {string} data 資料
 * @param {boolean} isJson 是否 Json
 */
 export const setStorage = (key, data, isJson = true) => {
  if (isJson) {
      localStorage[key] = JSON.stringify(data)
      return
  }
  localStorage[key] = data
}

/**
* 取得 localStorage 並判斷有無
* true 返回 localStorage 並進行 json 檢測
* false 返回空字串
* @param {string} key localStorage 的 Key
* @param {boolean} isJson 是否 Json
*/
export const getStorage = (key, isJson = true) => {
  try {
      const storage = localStorage[key]
      return isJson ? handleJson(storage) : storage || ''
  } catch (err) {
      return ''
  }
}

export default function throttleFn(fn, delay = 250) {
    let last
    // let timer
    return async function(...args) {
        const now = +new Date()
        if (last && now < last + delay) {
            // clearTimeout(timer)
            // timer = setTimeout(() => method.call(this), delay)
        } else {
            method.call(this)
        }
        function method() {
            last = now
            fn.apply(this, args)
        }
    }
}
